// TSS vite/04 §"Endpoint paths".
// Per-feature path helpers — keep URL knowledge local so a backend
// rename touches one file. Public channel (contract: public-client-channel.md).

export const donorPaths = {
    // GET public/donors — donadoras co-poseídas, scoped por client_id del token.
    list:   () => 'public/donors',
    // GET public/donors/:id — dashboard de UNA donadora (404 si no co-poseída).
    detail: (id) => `public/donors/${id}`,
    // GET public/stats — endpoint compartido (parcería + cowhousing + informe);
    // esta feature solo consume ?view=kpi → data.donors_kpi.
    stats:  () => 'public/stats',
    // GET public/liquidations — reparto mensual congelado del socio (D-009;
    // scoped por owner_client_id del token; ?animal_id con gate de co-propiedad).
    liquidations: () => 'public/liquidations',
};
